(() => {
  'use strict';
  if (window.AlmeoraPress) { window.AlmeoraPress.init(document); return; }
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const viewport = root.querySelector('[data-alm-press-viewport]');
    const track = root.querySelector('[data-alm-press-track]');
    const list = root.querySelector('[data-alm-press-list]');
    const toggle = root.querySelector('[data-alm-press-toggle]');
    if (!viewport || !track || !list || !toggle) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const listeners = [];
    let userPaused = false, hovered = false, focused = false;
    const copies = [];
    const listen = (target, event, callback, options) => {
      target.addEventListener(event, callback, options);
      listeners.push(() => target.removeEventListener(event, callback, options));
    };
    const createCopy = () => {
      const copy = list.cloneNode(true);
      copy.classList.add('alm-press__list--copy');
      copy.removeAttribute('data-alm-press-list');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('role', 'presentation');
      copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      copy.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
      copy.querySelectorAll('a,button,input,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
      track.append(copy);
      copies.push(copy);
    };
    const resize = () => {
      const span = list.getBoundingClientRect().width;
      root.style.setProperty('--alm-press-loop-width', span + 'px');
      const needed = list.children.length > 1 ? Math.max(1, Math.ceil(viewport.clientWidth / Math.max(1, span))) : 0;
      while (copies.length < needed) createCopy();
      while (copies.length > needed) copies.pop().remove();
    };
    resize();
    const update = () => {
      const animated = copies.length > 0 && !motion.matches;
      root.dataset.motion = animated ? 'animated' : 'static';
      root.dataset.paused = String(userPaused || hovered || focused || document.hidden);
      toggle.hidden = !animated;
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.setAttribute('aria-label', userPaused ? 'Play logo scrolling' : 'Pause logo scrolling');
      toggle.querySelector('[data-alm-press-toggle-label]').textContent = userPaused ? 'Play' : 'Pause';
      toggle.querySelector('[data-alm-press-toggle-icon]').textContent = userPaused ? '▶' : 'Ⅱ';
      if (animated) viewport.removeAttribute('tabindex');
      else viewport.tabIndex = 0;
    };
    listen(toggle, 'click', () => { userPaused = !userPaused; update(); });
    listen(root, 'pointerenter', () => { hovered = true; update(); });
    listen(root, 'pointerleave', () => { hovered = false; update(); });
    listen(root, 'focusin', event => {
      focused = true;
      if (list.contains(event.target)) {
        root.dataset.reading = 'true';
        requestAnimationFrame(() => event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}));
      }
      update();
    });
    listen(root, 'focusout', () => queueMicrotask(() => {
      focused = root.contains(document.activeElement);
      if (!focused) { root.dataset.reading = 'false'; viewport.scrollLeft = 0; }
      update();
    }));
    listen(document, 'visibilitychange', update);
    listen(motion, 'change', update);
    const resizeObserver = new ResizeObserver(() => { resize(); update(); });
    resizeObserver.observe(viewport);
    instances.set(root, () => { listeners.forEach(remove => remove()); resizeObserver.disconnect(); copies.forEach(copy => copy.remove()); instances.delete(root); });
    update();
  }
  function init(scope) {
    if (scope.matches?.('[data-alm-press]')) mount(scope);
    scope.querySelectorAll?.('[data-alm-press]').forEach(mount);
  }
  window.AlmeoraPress = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll?.('[data-alm-press]').forEach(root => instances.get(root)?.());
  });
})();
